module.exports = __webpack_public_path__ + "img/layout-10_3.ed432944.png";